cb.define([], function () {
  var RM_rm_salereceipts_report_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },

    init: function (viewmodel) {
      viewmodel.getGridModel().on('beforeLoad', function (data) {
        debugger;
        if (viewmodel.get("groupSchemas"))
        {
            if (viewmodel.get("groupSchemas").getSelectedNodes()) {
              if (viewmodel.get("groupSchemas").getSelectedNodes().name == "待日结数据") {
                if (data.condition) {
                  var defwhere = {};
                  data.condition['isExtend'] = true;
                  data.condition['simpleVOs'] = [];
                  defwhere['field'] = 'fbitSettle';
                  defwhere['value1'] = 0;
                  defwhere['op'] = 'eq';
                  data.condition['simpleVOs'].push(defwhere);
/*				          defwhere = {};
                  defwhere['field'] = 'iPresellState';
                  defwhere['value1'] = '5';
                  defwhere['op'] = 'neq';
                  data.condition['simpleVOs'].push(defwhere);
				  */
                }
              }
              else {
                if (data.condition)
                {
			/*
                  var defwhere = {};
                  data.condition['isExtend'] = true;
                  data.condition['simpleVOs'] = [];
                  defwhere['field'] = 'iPresellState';
                  defwhere['value1'] = '5';
                  defwhere['op'] = 'neq';
                  data.condition['simpleVOs'].push(defwhere);  
*/				  
                }
              }
            }
			else
			{
				if (data.condition)
                {
					/*
                  var defwhere = {};
                  data.condition['isExtend'] = true;
                  data.condition['simpleVOs'] = [];
                  defwhere['field'] = 'iPresellState';
                  defwhere['value1'] = '5';
                  defwhere['op'] = 'neq';
                  data.condition['simpleVOs'].push(defwhere); 
				  */
				}
			}
        }
		else
			{
				if (data.condition)
                {
					/*
                  var defwhere = {};
                  data.condition['isExtend'] = true;
                  data.condition['simpleVOs'] = [];
                  defwhere['field'] = 'iPresellState';
                  defwhere['value1'] = '5';
                  defwhere['op'] = 'neq';
                  data.condition['simpleVOs'].push(defwhere); 
				  */
				}
			}
      });

    }
  }
  try {
    module.exports = RM_rm_salereceipts_report_VM_Extend;
  } catch (error) {

  }
  return RM_rm_salereceipts_report_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_salereceipts_report_VM.Extend.js